// extracted by mini-css-extract-plugin
module.exports = {"container":"community-header_container__3LQRg","titleContainer":"community-header_titleContainer__2tOOZ","title":"community-header_title__12e9c"};